import { UserRole } from '../models/userRole';

export const filterUserRoles = (
  userRoles: Array<UserRole>,
  roleNames: Array<string>
) => userRoles.filter((userRole) => roleNames.includes(userRole.roleName));
